import React from 'react';
import PropTypes from 'prop-types';

import Picture from '@Theme/hellofinance/components/Picture/Picture';

import * as styles from './GenericTeam.module.scss';

const propTypes = {
  /**
   * Author image
   */
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),

  /**
   * Author name
   */
  fullName: PropTypes.string,

  /**
   * Author role
   */
  role: PropTypes.string,

  /**
   * Author link
   */
  href: PropTypes.string
};

const GenericAuthorItem = ({
  image,
  fullName,
  role,
  href
}) => {
  if (!image && !fullName && !role) {
    return false;
  }

  const Component = href ? 'a' : 'div';

  return <Component className={styles.rootAuthor} href={href}>
    {(image && image.src) && <Picture xs={{
      src: image.src
    }}
    alt={image.alt}
    imgClassname={styles.rootAuthorImage}
    pictureClassname={styles.rootAuthorPicture}/>}
    {fullName && <p className={styles.rootAuthorName}>{fullName}</p>}
    {role && <p className={styles.rootAuthorRole}>{role}</p>}
  </Component>;
};

GenericAuthorItem.propTypes = propTypes;

export default GenericAuthorItem;
